export default __webpack_public_path__ + "static/media/Biggiess.f353e0ef.png";